import React, { FunctionComponent, MouseEvent, SyntheticEvent, useEffect, useRef, useState, } from 'react'
import { useTranslation, Trans, } from 'react-i18next';
import AuthLayout from '../../layouts/AuthLayout/AuthLayout';

import './FAQ.css';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
} from '@mui/material';

import { ExpandMore, Link } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../store/store';
import { push } from '@lagunovsky/redux-react-router';
import { supportedClients } from '../../clients';
import { feedback } from '../../components/Feedback/feedback';

interface Props {
}

const FAQ:FunctionComponent<Props> = () => {

  const { t } = useTranslation( [ 'faq' ] );
  const stickyElement = useRef( null );

  const dispatch = useDispatch<AppDispatch>();

  const [ expanded, setExpanded ] = useState<string | false>( false );

  const onPanel = (panel: string, isExpanded: boolean, ) => {
    location.hash = panel;
    setExpanded(isExpanded ? panel : false);
  };

  interface Interchange {
    id: string,
    question: string,
    answer: JSX.Element,
  }

  const onLogin = () => {

    dispatch( push( '/' ) );
  }

  // Instead of normal link behavior,
  // we need to prevent default
  // and use push action from redux-react-router
  const onLink = ( event: MouseEvent ) => {

    event.preventDefault();

    const a = event.target as HTMLAnchorElement;
    dispatch( push( new URL( a.href ).pathname ) );
  }

  // Cool feature, need to ask PO first
  // Feature is going to be in second iteration anyway
  // const onCopy = () => {

  //   navigator.clipboard.writeText( window.location.href ).then( () => {

  //     dispatch( feedback( { message: t( 'linkCopied' ) } ) );
  //   } ).catch( () => {

  //     dispatch( feedback( { message: t( 'copyError' ), severity: 'error' } ) );
  //   });
  // }

  // This observer observes is sticky element is visible, we need to do this
  // in order to dynamicially show a shadow at the top of sticky element
  const observer = new IntersectionObserver( ( entries ) => {
    const firstEntry = entries[ 0 ];
    firstEntry.target.classList
      .toggle( 'page-faq__sticky--not-pinned', firstEntry.intersectionRatio < 1 );
  }, { threshold: [1] },);

  useEffect( () => {

    // If hash in url is the same as id of the question: expand accordion section
    const hash = window.location.hash.substring( 1 );
    if( questions.find(  ( { id } ) => id === hash ) ) {
      onPanel( hash, true );
    }

    // Mount / unmount sticky element shadow observer
    if ( stickyElement.current ) observer.observe( stickyElement.current );
    return () => {
      observer.disconnect();
    };
  }, [] );

  const answerClickOnForgotPassword = ( <div>
      <p><Trans t={ t } i18nKey="clickOnForgotPassword">0<a href="/forgot-password" onClick={ onLink }>1</a>2</Trans></p>
      <p>{ t( 'alternativeContactSupport' ) }</p>
  </div> );

  const questions: Interchange[] = [ {
    // Interchange 1
    id: 'what-is-a-hella-gutmann-account',
    question: t( 'whatIsAHellaGutmannAccount' ),
    answer: ( <div>
      <p>{t( 'itIsASingleSignOnSolution' )}</p>
      <p>{t( 'possibleToUseMultipleAccounts' )}</p>
    </div>),
  }, {
    // Interchange 2
    id: 'which-apps-are-supported',
    question: t( 'whichAppsAreSupported'),
    answer: ( <div>{ t( 'supportedAppsConstantlyExpanded' ) }:<ul>
      { supportedClients.map( ( { extendedName }, index ) => (
        <li key={ index }>{ extendedName }</li>
      ) ) }
      </ul></div> )
  }, {
    // Interchange 3
    id: 'how-do-i-get-a-hella-gutmann-account',
    question: t( 'howDoIGetAHellaGutmannAccount'),
    answer: ( <p>{ t( 'asSoonAsYouGetAccessToProducts') }</p> ),
  }, {
    // Interchange 4
    id: 'what-to-do-if-no-email-received',
    question: t( 'whatToDoIfNoEMailReceived' ),
    answer: answerClickOnForgotPassword,
  }, {
    // Interchange 5
    id: 'how-do-i-reset-password',
    question: t( 'howDoIResetPassword' ),
    answer: answerClickOnForgotPassword,
  }, {
    // Interchange 6
    id: 'how-do-i-change-email-address',
    question: t( 'howDoIChangeEmailAddress'),
    answer: ( <div>
      <p>{t( 'changeEmailOnUserProfile' )}</p>
      <p>{t( 'alternativeContactSupport' )}</p>
    </div>),
  },{
    // Interchange 7
    id: 'how-do-i-change-password',
    question: t( 'howDoIChangePassword'),
    answer: ( <div>
      <p>{t( 'changePasswordOnUserProfile' )}</p>
      <p>{t( 'alternativeContactSupport' )}</p>
    </div>),
  } ];


  return (<AuthLayout header={ true }>
    <h2>{ t( 'title' ) }</h2>
    <div className="page page-faq">
      <div className="page-faq__accordion">
        { questions.map( ( { id, question, answer, }, index ) => (
        <Accordion
          elevation={ 0 }
          key={ index }
          expanded={ expanded === id }
          onChange={ (event: SyntheticEvent, isExpanded: boolean) => onPanel( id, isExpanded ) }
        >
          <AccordionSummary
            expandIcon={<ExpandMore />}
          ><h3 id={ id }>{ question }</h3></AccordionSummary>
          <AccordionDetails>
            <section className="page-faq__section">{ answer }</section>
            {/* Cool feature, need to ask PO first */}
            {/* Feature is going to be in second iteration anyway */}
            {/* <Button onClick={ onCopy }><span className="page-faq__copy-link">{ t( 'copyLink' ) }<Link></Link></span></Button> */}
          </AccordionDetails>
        </Accordion>
        ) ) }
      </div>
      <div className="page-faq__sticky" ref={ stickyElement }>
        <Button
          variant="contained"
          fullWidth={ true }
          onClick={ onLogin }
        >{ t( 'backToLogin' ) }</Button>
      </div>
    </div>
  </AuthLayout>)

}

export default FAQ;
